import { NgClass, PercentPipe } from '@angular/common'
import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core'
import { MatProgressBarModule } from '@angular/material/progress-bar'

@Component({
  selector: 'lib-progress-bar',
  imports: [NgClass, MatProgressBarModule, PercentPipe],
  templateUrl: './progress-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './progress-bar.component.scss',
})
export class ProgressBarComponent {
  readonly value = input.required<number>()
  readonly emptyText = input<string>()

  readonly clippedValue = computed(() => {
    return Math.min(Math.max(this.value(), 0), 1)
  })
}
